import { ArrowUpRight, MessageCircle, Phone, Mail, MapPin, Clock } from "lucide-react";
import { Seo, breadcrumbSchema } from "@/components/layout/Seo";
import { PageHero, Reveal } from "@/components/ui/motion";
import { ConsultForm } from "@/components/sections/ConsultForm";
import { SITE, waLink } from "@/lib/config";
import { IgIcon } from "@/components/ui/IgIcon";

export default function Contact() {
  const crumbs = [{ to: "/", label: "Beranda" }, { to: "/kontak", label: "Kontak" }];
  const items = [
    { icon: MessageCircle, label: "WhatsApp", value: "+62 812-1424-0919", href: waLink(), testId: "contact-wa" },
    { icon: Phone, label: "Telepon kantor", value: SITE.phone, href: SITE.phoneHref, testId: "contact-phone" },
    { icon: Mail, label: "Email", value: SITE.email, href: `mailto:${SITE.email}`, testId: "contact-email" },
    { icon: IgIcon, label: "Instagram", value: `@${SITE.instagram}`, href: SITE.instagramUrl, testId: "contact-instagram" },
  ];
  return (
    <>
      <Seo title="Kontak | Mika Solution" description="Hubungi Mika Solution melalui WhatsApp atau formulir konsultasi untuk memulai konsultasi kewajiban pinjol, kartu kredit, atau KTA." path="/kontak" schema={[breadcrumbSchema(crumbs)]} />
      <PageHero crumbs={crumbs} eyebrow="Kontak" lines={["Mari Mulai", <span className="serif-it font-normal text-accentb">Berbicara.</span>]} desc="Pilih cara yang paling nyaman bagi Anda. Konsultasi awal tidak dikenakan biaya." />
      <section className="py-16 sm:py-24" data-testid="contact-info">
        <div className="wrap grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {items.map(({ icon: Icon, label, value, href, testId }, i) => {
            const body = (
              <>
                <span className="grid h-12 w-12 place-items-center rounded-2xl bg-ice text-accentb"><Icon size={20} /></span>
                <span className="mt-8 block text-[12px] font-bold uppercase tracking-[0.16em] text-ink-soft">{label}</span>
                <span className="mt-2 flex items-center gap-2 break-all font-display text-lg font-bold text-slateb">{value}{href && <ArrowUpRight size={16} className="shrink-0 text-accentb" />}</span>
              </>
            );
            return (
              <Reveal key={label} delay={i * 0.05}>
                {href ? (
                  <a href={href} target="_blank" rel="noopener noreferrer" className="card block h-full p-7 transition-colors hover:border-sky-brand" data-testid={testId}>{body}</a>
                ) : (
                  <div className="card h-full p-7" data-testid={testId}>{body}</div>
                )}
              </Reveal>
            );
          })}
        </div>
      </section>
      <section className="pb-16 sm:pb-24" data-testid="contact-office">
        <div className="wrap grid grid-cols-1 gap-5 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <div className="card h-full p-8 sm:p-10">
              <span className="grid h-12 w-12 place-items-center rounded-2xl bg-ice text-accentb"><MapPin size={20} /></span>
              <p className="mt-8 text-[12px] font-bold uppercase tracking-[0.16em] text-ink-soft">Kantor pusat — {SITE.parent.name}</p>
              <p className="mt-3 font-display text-2xl font-bold leading-snug text-slateb" data-testid="contact-address">{SITE.address}</p>
              <a href={SITE.mapsUrl} target="_blank" rel="noopener noreferrer" className="btn btn-ghost mt-8" data-testid="contact-maps-link">Buka di Google Maps <ArrowUpRight size={16} /></a>
              <div className="mt-8 flex items-start gap-3 border-t border-line pt-6 text-[14px] text-ink" data-testid="contact-hours"><Clock size={18} className="mt-0.5 shrink-0 text-accentb" />{SITE.hours}</div>
            </div>
          </Reveal>
          <Reveal className="lg:col-span-7" delay={0.08}>
            <div className="relative h-full min-h-[360px] overflow-hidden rounded-[1.5rem] border border-line shadow-[0_40px_80px_-50px_rgba(51,78,104,.5)] lg:min-h-[440px]">
              <iframe title="Peta kantor Mitra Karya Law Office" src={SITE.mapsEmbed} className="absolute inset-0 h-full w-full" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid="contact-map" />
            </div>
          </Reveal>
        </div>
      </section>
      <ConsultForm />
    </>
  );
}
